import React from 'react';
import { Colors, PrimaryButton, Text } from 'library';
import { Grid } from '@material-ui/core';
import { useModalsContext } from 'ModalsContext';
import moment from 'moment';
import { isBefore, isToday } from 'date-fns';

export default function PostAShiftCard({ d, addressId }: { d: Date; addressId?: number }) {
    const { openJobForm } = useModalsContext();
    if (isBefore(d, new Date()) && !isToday(d)) {
        return <></>;
    }
    return (
        <Grid
            item
            key={d.toLocaleDateString() + 'job'}
            container
            direction="column"
            style={{ padding: '20px 20px 0px 20px' }}
            alignContent="center"
        >
            <Grid
                item
                container
                style={{
                    borderRadius: 18,
                    backgroundColor: Colors.lightTurq,
                    padding: 10,
                    boxShadow: '0px 3px 6px 0px #00000029',
                }}
            >
                <Text variant="body1" textStyle={{ marginBottom: 20 }}>
                    Post a shift for {d.toLocaleDateString()}.
                </Text>
                <PrimaryButton
                    buttonStyle={{ width: 'unset' }}
                    onClick={() =>
                        openJobForm(`Post a job card (Business Calendar)`, {
                            startDate: moment(d),
                            endDate: moment(d),
                            address: addressId ? [addressId] : undefined,
                        })
                    }
                >
                    Post Shift
                </PrimaryButton>
            </Grid>
        </Grid>
    );
}
